import { IStoreState } from "@montana/store/store";
import { generateContainer, IContainerProps } from "../base/generate-container";
import { setCustomerInformation, loadCustomerInformation, loadShippingInformation, setShippingInformation } from '.';
import { ICheckoutContainerState } from "./checkout";

const mapState = ({ checkout }: IStoreState): ICheckoutContainerState => ({ ...checkout });

const actions = {
    setCustomerInformation,
    loadCustomerInformation,
    loadShippingInformation,
    setShippingInformation,
};

export type ICheckoutContainerProps = IContainerProps<ReturnType<typeof mapState>, typeof actions>;

export const [CheckoutContainer, connectWithCheckout, useCheckout] = generateContainer(mapState, actions);
